import WebGLDestructible from 'mediamonks-webgl/renderer/core/WebGLDestructible';
import Transform from '../../renderer/core/Transform';
import Quaternion from '../../renderer/math/Quaternion';
import Utils from "mediamonks-webgl/renderer/core/Utils";

/**
 * Created by reinder on 8-12-2015.
 */

class Gyroscope extends WebGLDestructible {
  private _isEnabled: boolean = false;
  private _isDeviceAvailable: boolean = false;

  private _transform: Transform;
  private _eventBind: boolean = false;

  private _target: Quaternion = new Quaternion();
  private _current: Quaternion = new Quaternion();
  private _screen: Quaternion = new Quaternion();
  private _tempTransform: Transform = new Transform();
  private _worldRot: Quaternion = new Quaternion(-Math.sqrt(.5), 0, 0, Math.sqrt(.5));

  constructor(touchElement: HTMLElement, transform: Transform) {
    super();
    this._transform = transform;

    // @ts-ignore
    if (typeof DeviceMotionEvent.requestPermission === 'function') {
      let requested = false;
      window.addEventListener('click', () => {
        if (requested) {
          return;
        }
        requested = true;
        // @ts-ignore
        DeviceOrientationEvent.requestPermission()
          .then((response: any) => {
            if (response == 'granted') {
              this.enable();
            }
          })
          .catch((response: any) => {
          });
      });
    } else {
      this.enable();
    }
  }

  public enable(): void {
    if ('ondeviceorientation' in window) {
      this._isDeviceAvailable = true;
    }

    if (this._isDeviceAvailable) {
      if (!this._eventBind) {
        window.addEventListener('deviceorientation', (e) => {
          this.handleDeviceOrientation(e);
        }, false);
        this._eventBind = true;
      }

      this._isEnabled = true;
    }
  }

  public isEnabled(): boolean {
    return this._isEnabled && this._isDeviceAvailable;
  }

  public disable(): void {
    this._isEnabled = false;
  }

  private handleDeviceOrientation(event: DeviceOrientationEvent) {
    if (this._isEnabled) {
      const screenOrientation = window.orientation || 0;

      this._tempTransform.setEulerValues(Utils.degToRad(<number>event['beta']), Utils.degToRad(<number>event['alpha']), -Utils.degToRad(<number>event['gamma']));
      this._target.copy(this._tempTransform.rotation);

      const minusHalfAngle = -screenOrientation / 2 * Math.PI / 180;
      this._screen.setValues(0, Math.sin(minusHalfAngle), 0, Math.cos(minusHalfAngle));

      this._target.multiply(this._screen);
      this._target.multiply(this._worldRot);

      this._current = Quaternion.closestSlerp(this._current, this._target, 0.7);
      this._transform.rotation = this._current;
    }
  }

  public get rotation(): Quaternion {
    return this._current;
  }
}

export default Gyroscope;
